import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { STATUS } from '../../common/use-loading.model';
import { User } from './user.model';
import { users } from './user.mock';

@Injectable({
  providedIn: 'root'
})
export class EoUserDropdownService {
  users$ = new BehaviorSubject<User[]>([]);
  status$ = new BehaviorSubject<STATUS>(STATUS.pending);
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  getUsers(url: string): Observable<User[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.users$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<User[]>(param);
  }

  getUsersMock(): Observable<User[]> {
    this.status$.next(STATUS.loading);
    const obs$ = new Observable<User[]>((sub) => {
      setTimeout(() => {
        sub.next(users);
        this.users$.next(users);
        this.status$.next(STATUS.success);
      }, 1000);
    });

    return obs$;
  }
}
